import styles from './FJUrlToVideoStart.module.less';
import FJLocalStore from '../../../store/FJLocalStore.js';
import FJFreeTimesSpan from '../FJFreeTimesSpan/FJFreeTimesSpan.jsx';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import FJConfig from '../../../config/FJConfig.js';
import FJCloseIcon from '../../../assets/svg/textToVideo/close.svg?react';
import { TEXT_TO_VIDEO_PRICE } from '../../../config/dataConfig/FJTextToVideoDataConfig.js';
import FJGenerateButton from '../../../common/components/FJGenerateButton/FJGenerateButton.jsx';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller.jsx';
const FJUrlToVideoStart = props => {
    const { urlToVideoInput, onChangeUrlToVideoInput, onAnalyzeUrl, freeTimes, creditNumber } = props;
    const _onChange = useCallback(
        e => {
            onChangeUrlToVideoInput(e.target.value);
        },
        [onChangeUrlToVideoInput],
    );
    const _onClose = useCallback(() => {
        onChangeUrlToVideoInput('');
    }, [onChangeUrlToVideoInput]);
    const isFree = freeTimes > 0 && creditNumber < TEXT_TO_VIDEO_PRICE.analysisUrl;
    return (
        <FJVerticalScroller
            className={styles.container}
            style={{ backgroundImage: `url(${FJConfig.resourceImagePath}url-to-video-bg.png)` }}
        >
            <div className={styles.title}>{FJLocalStore._('ai-blog-url-to-video')}</div>
            <div className={styles.input_box}>
                <input
                    value={urlToVideoInput}
                    onChange={_onChange}
                    className={styles.input}
                    type='text'
                    placeholder={FJLocalStore._('paste-your-blog-or-article-url-here')}
                />
                {urlToVideoInput && (
                    <div className={styles.close_icon_box} onClick={_onClose}>
                        <FJCloseIcon className={styles.close_icon} />
                    </div>
                )}
                {/* <div className={styles.sample}>{FJLocalStore._('try-sample-links')}</div> */}
            </div>

            <FJGenerateButton
                text={FJLocalStore._('analyze-url')}
                className={styles.btn}
                onClick={onAnalyzeUrl}
                isFree={isFree}
                useCredit={TEXT_TO_VIDEO_PRICE.analysisUrl}
                hideFreeCreation={true}
            />
            {isFree && <FJFreeTimesSpan times={freeTimes} />}
        </FJVerticalScroller>
    );
};

FJUrlToVideoStart.propTypes = {
    urlToVideoInput: PropTypes.string,
    onChangeUrlToVideoInput: PropTypes.func,
    onAnalyzeUrl: PropTypes.func,
    freeTimes: PropTypes.number,
    creditNumber: PropTypes.number,
};

export default FJUrlToVideoStart;
